<script setup lang="ts">
import Field from './Field.vue';
import { fieldPropDefs, useFieldProps } from './props';

const props = defineProps(fieldPropDefs);
const emit = defineEmits(['update:modelValue']);
const { id, fieldProps, modelValue } = useFieldProps(props, emit);
</script>

<template>
    <Field v-bind="fieldProps">
        <div>
            <Textarea
                :id="id"
                v-model="modelValue"
                :name="props.name"
                class="field-input"
                :class="props.inputClass"
                :style="props.inputStyle"
                :required="props.required"
                v-bind="$attrs"
            />
        </div>
    </Field>
</template>
